import React, {ReactNode} from "react";
import {AbstractPanel, AbstractPanelProperties, AbstractPanelState} from "./AbstractPanel";
import Translate from "../../shared/translation/Translate";
import portalConfiguration from "../../shared/configuration/PortalConfiguration";
import Helper from "../../shared/components/Helper";
import Icon from "../../shared/components/Icon";

export interface DocumentationPanelProperties extends AbstractPanelProperties {
}

export interface DocumentationPanelState extends AbstractPanelState {
}

export class DocumentationPanelDefinition extends AbstractPanel<DocumentationPanelProperties, DocumentationPanelState> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		return (
			<div className="screen admin-documentation-panel" data-help="global.screen.admin.content"
				 data-position="top">
				<div className="body">
					<h1>
						<Translate {...this.props} data={"adminscreen.panels.documentation.title"} namespace="screen"/>
						{this.renderHelpButton()}
					</h1>
					<Helper {...this.props}>
						<Translate {...this.props} data={"global.screen.admin.documentation"} namespace={"help"}
								   markdown={true}/>
					</Helper>
					<div className="p-grid">
						<fieldset className="p-col-12 p-grid">
							<div>
								<h2>
									<Translate {...this.props} data={"adminscreen.panels.documentation.help.label"}
											   namespace="screen"/>
								</h2>
								<ul>
									<li>
										<a target="_blank" rel="noreferrer" href={
											Translate.value(
												"adminscreen.panels.documentation.help.manual.url",
												{ns: "screen"}
											)
										}>
											<Translate {...this.props} namespace="screen"
													   data={"adminscreen.panels.documentation.help.manual.label"}/>
											<Icon icon={"icon-external"}/>
										</a>
									</li>
								</ul>
							</div>
							<div className="p-col-12">
								<h2>
									<Translate {...this.props} namespace="screen"
											   data={"adminscreen.panels.documentation.interfaces.label"}/>
								</h2>

								<div className="doc-block p-grid">
									<div>
										<h3>
											<Translate {...this.props} namespace="screen"
													   data={"adminscreen.panels.documentation.interfaces.rest.label"}/>
										</h3>
										<ul>
											<li>
												<a target="_blank" rel="noreferrer" href={
													Translate.value(
														"adminscreen.panels.documentation.interfaces.rest.documentation.url",
														{ns: "screen"}
													)
												}>
													<Translate {...this.props} namespace="screen" data={
														"adminscreen.panels.documentation.interfaces.rest.documentation.label"
													}/>
													<Icon icon={"icon-external"}/>
												</a>
												<ul>
													<li>
														<a target="_blank" rel="noreferrer" href={
															Translate.value(
																"adminscreen.panels.documentation.interfaces.rest.converter.url",
																{ns: "screen"}
															)
														}>
															<Translate {...this.props} namespace="screen" data={
																"adminscreen.panels.documentation.interfaces.rest.converter.label"
															}/>
															<Icon icon={"icon-external"}/>
														</a>
													</li>
													<li>
														<a target="_blank" rel="noreferrer" href={
															Translate.value(
																"adminscreen.panels.documentation.interfaces.rest.signature.url",
																{ns: "screen"}
															)
														}>
															<Translate {...this.props} namespace="screen" data={
																"adminscreen.panels.documentation.interfaces.rest.signature.label"
															}/>
															<Icon icon={"icon-external"}/>
														</a>
													</li>
													<li>
														<a target="_blank" rel="noreferrer" href={
															Translate.value(
																"adminscreen.panels.documentation.interfaces.rest.pdfa.url",
																{ns: "screen"}
															)
														}>
															<Translate {...this.props} namespace="screen" data={
																"adminscreen.panels.documentation.interfaces.rest.pdfa.label"
															}/>
															<Icon icon={"icon-external"}/>
														</a>
													</li>
													<li>
														<a target="_blank" rel="noreferrer" href={
															Translate.value(
																"adminscreen.panels.documentation.interfaces.rest.toolbox.url",
																{ns: "screen"}
															)
														}>
															<Translate {...this.props} namespace="screen" data={
																"adminscreen.panels.documentation.interfaces.rest.toolbox.label"
															}/>
															<Icon icon={"icon-external"}/>
														</a>
													</li>
													<li>
														<a target="_blank" rel="noreferrer" href={
															Translate.value(
																"adminscreen.panels.documentation.interfaces.rest.ocr.url",
																{ns: "screen"}
															)
														}>
															<Translate {...this.props} namespace="screen" data={
																"adminscreen.panels.documentation.interfaces.rest.ocr.label"
															}/>
															<Icon icon={"icon-external"}/>
														</a>
													</li>
													<li>
														<a target="_blank" rel="noreferrer" href={
															Translate.value(
																"adminscreen.panels.documentation.interfaces.rest.urlconverter.url",
																{ns: "screen"}
															)
														}>
															<Translate {...this.props} namespace="screen" data={
																"adminscreen.panels.documentation.interfaces.rest.urlconverter.label"
															}/>
															<Icon icon={"icon-external"}/>
														</a>
													</li>
													<li>
														<a target="_blank" rel="noreferrer" href={
															Translate.value(
																"adminscreen.panels.documentation.interfaces.rest.barcode.url",
																{ns: "screen"}
															)
														}>
															<Translate {...this.props} namespace="screen" data={
																"adminscreen.panels.documentation.interfaces.rest.barcode.label"
															}/>
															<Icon icon={"icon-external"}/>
														</a>
													</li>
												</ul>
											</li>
											<li>
												<a target="_blank" rel="noreferrer" href={
													Translate.value(
														"adminscreen.panels.documentation.interfaces.rest.json.url",
														{ns: "screen", baseurl: portalConfiguration.baseUrl}
													)
												}>
													<Translate {...this.props} namespace="screen" data={
														"adminscreen.panels.documentation.interfaces.rest.json.label"
													}/>
												</a>
											</li>
											<li>
												<a target="_blank" rel="noreferrer" href={
													Translate.value(
														"adminscreen.panels.documentation.interfaces.rest.yaml.url",
														{ns: "screen", baseurl: portalConfiguration.baseUrl}
													)
												}>
													<Translate {...this.props} namespace="screen" data={
														"adminscreen.panels.documentation.interfaces.rest.yaml.label"
													}/>
												</a>
											</li>
											<li>
												<a target="_blank" rel="noreferrer" href={
													Translate.value(
														"adminscreen.panels.documentation.interfaces.rest.swagger.url",
														{ns: "screen", baseurl: portalConfiguration.baseUrl}
													)
												}>
													<Translate {...this.props} namespace="screen" data={
														"adminscreen.panels.documentation.interfaces.rest.swagger.label"
													}/>
												</a>
											</li>
										</ul>
									</div>
									<div>
										<h3>
											<Translate {...this.props} namespace="screen"
													   data={"adminscreen.panels.documentation.interfaces.soap.label"}/>
										</h3>
										<ul>
											<li>
												<a target="_blank" rel="noreferrer" href={
													Translate.value(
														"adminscreen.panels.documentation.interfaces.soap.documentation.url",
														{ns: "screen"}
													)
												}>
													<Translate {...this.props} namespace="screen" data={
														"adminscreen.panels.documentation.interfaces.soap.documentation.label"
													}/>
													<Icon icon={"icon-external"}/>
												</a>
												<ul>
													<li>
														<a target="_blank" rel="noreferrer" href={
															Translate.value(
																"adminscreen.panels.documentation.interfaces.soap.converter.url",
																{ns: "screen"}
															)
														}>
															<Translate {...this.props} namespace="screen" data={
																"adminscreen.panels.documentation.interfaces.soap.converter.label"
															}/>
															<Icon icon={"icon-external"}/>
														</a>
													</li>
													<li>
														<a target="_blank" rel="noreferrer" href={
															Translate.value(
																"adminscreen.panels.documentation.interfaces.soap.signature.url",
																{ns: "screen"}
															)
														}>
															<Translate {...this.props} namespace="screen" data={
																"adminscreen.panels.documentation.interfaces.soap.signature.label"
															}/>
															<Icon icon={"icon-external"}/>
														</a>
													</li>
													<li>
														<a target="_blank" rel="noreferrer" href={
															Translate.value(
																"adminscreen.panels.documentation.interfaces.soap.pdfa.url",
																{ns: "screen"}
															)
														}>
															<Translate {...this.props} namespace="screen" data={
																"adminscreen.panels.documentation.interfaces.soap.pdfa.label"
															}/>
															<Icon icon={"icon-external"}/>
														</a>
													</li>
													<li>
														<a target="_blank" rel="noreferrer" href={
															Translate.value(
																"adminscreen.panels.documentation.interfaces.soap.toolbox.url",
																{ns: "screen"}
															)
														}>
															<Translate {...this.props} namespace="screen" data={
																"adminscreen.panels.documentation.interfaces.soap.toolbox.label"
															}/>
															<Icon icon={"icon-external"}/>
														</a>
													</li>
													<li>
														<a target="_blank" rel="noreferrer" href={
															Translate.value(
																"adminscreen.panels.documentation.interfaces.soap.ocr.url",
																{ns: "screen"}
															)
														}>
															<Translate {...this.props} namespace="screen" data={
																"adminscreen.panels.documentation.interfaces.soap.ocr.label"
															}/>
															<Icon icon={"icon-external"}/>
														</a>
													</li>
													<li>
														<a target="_blank" rel="noreferrer" href={
															Translate.value(
																"adminscreen.panels.documentation.interfaces.soap.urlconverter.url",
																{ns: "screen"}
															)
														}>
															<Translate {...this.props} namespace="screen" data={
																"adminscreen.panels.documentation.interfaces.soap.urlconverter.label"
															}/>
															<Icon icon={"icon-external"}/>
														</a>
													</li>
													<li>
														<a target="_blank" rel="noreferrer" href={
															Translate.value(
																"adminscreen.panels.documentation.interfaces.soap.barcode.url",
																{ns: "screen"}
															)
														}>
															<Translate {...this.props} namespace="screen" data={
																"adminscreen.panels.documentation.interfaces.soap.barcode.label"
															}/>
															<Icon icon={"icon-external"}/>
														</a>
													</li>
												</ul>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div className="p-col-12">
								<h2>
									<Translate {...this.props} namespace="screen"
											   data={"adminscreen.panels.documentation.schemas.label"}/>
								</h2>
								<h3>
									<Translate {...this.props} namespace="screen"
											   data={"adminscreen.panels.documentation.schemas.xsd.label"}/>
								</h3>
								<ul>
									<li>
										<a target="_blank" rel="noreferrer" href={
											Translate.value(
												"adminscreen.panels.documentation.schemas.xsd.operation.url",
												{ns: "screen", baseurl: portalConfiguration.baseUrl}
											)
										}>
											<Translate {...this.props} namespace="screen" data={
												"adminscreen.panels.documentation.schemas.xsd.operation.label"
											}/>
											<Icon icon={"icon-external"}/>
										</a>
									</li>
									<li>
										<a target="_blank" rel="noreferrer" href={
											Translate.value(
												"adminscreen.panels.documentation.schemas.xsd.Barcode.url",
												{ns: "screen", baseurl: portalConfiguration.baseUrl}
											)
										}>
											<Translate {...this.props} namespace="screen" data={
												"adminscreen.panels.documentation.schemas.xsd.Barcode.label"
											}/>
											<Icon icon={"icon-external"}/>
										</a>
									</li>
									<li>
										<a target="_blank" rel="noreferrer" href={
											Translate.value(
												"adminscreen.panels.documentation.schemas.xsd.export.url",
												{ns: "screen", baseurl: portalConfiguration.baseUrl}
											)
										}>
											<Translate {...this.props} namespace="screen" data={
												"adminscreen.panels.documentation.schemas.xsd.export.label"
											}/>
											<Icon icon={"icon-external"}/>
										</a>
									</li>
									<li>
										<a target="_blank" rel="noreferrer" href={
											Translate.value(
												"adminscreen.panels.documentation.schemas.xsd.metadata.url",
												{ns: "screen", baseurl: portalConfiguration.baseUrl}
											)
										}>
											<Translate {...this.props} namespace="screen" data={
												"adminscreen.panels.documentation.schemas.xsd.metadata.label"
											}/>
											<Icon icon={"icon-external"}/>
										</a>
									</li>
									<li>
										<a target="_blank" rel="noreferrer" href={
											Translate.value(
												"adminscreen.panels.documentation.schemas.xsd.forms.url",
												{ns: "screen", baseurl: portalConfiguration.baseUrl}
											)
										}>
											<Translate {...this.props} namespace="screen" data={
												"adminscreen.panels.documentation.schemas.xsd.forms.label"
											}/>
											<Icon icon={"icon-external"}/>
										</a>
									</li>
									<li>
										<a target="_blank" rel="noreferrer" href={
											Translate.value(
												"adminscreen.panels.documentation.schemas.xsd.pdfa.url",
												{ns: "screen", baseurl: portalConfiguration.baseUrl}
											)
										}>
											<Translate {...this.props} namespace="screen" data={
												"adminscreen.panels.documentation.schemas.xsd.pdfa.label"
											}/>
											<Icon icon={"icon-external"}/>
										</a>
									</li>
									<li>
										<a target="_blank" rel="noreferrer" href={
											Translate.value(
												"adminscreen.panels.documentation.schemas.xsd.billing.url",
												{ns: "screen", baseurl: portalConfiguration.baseUrl}
											)
										}>
											<Translate {...this.props} namespace="screen" data={
												"adminscreen.panels.documentation.schemas.xsd.billing.label"
											}/>
											<Icon icon={"icon-external"}/>
										</a>
									</li>
								</ul>
							</div>
						</fieldset>
					</div>
				</div>
			</div>
		);
	}
}

const DocumentationPanel = React.memo(DocumentationPanelDefinition,
	(
		prevProps: Readonly<DocumentationPanelProperties>,
		nextProps: Readonly<DocumentationPanelProperties>
	) => {
		if (nextProps.contentMode !== prevProps.contentMode) {
			return false;
		}

		if (prevProps.language !== nextProps.language) {
			return false;
		}

		if (prevProps.showHelp !== nextProps.showHelp) {
			return false;
		}

		return true;
	}
);

export default DocumentationPanel;